import { useLocation } from "react-router-dom";
import { useLicensing } from "../auth/LicensingProvider";
import { LicensingModuleKeys } from "../types/licensing.types";
import { ModuleDisabled } from "./ModuleDisabled";
import { NotFoundPage } from "./NotFoundPage";

/** URL prefix -> the module it belongs to, for paths no route claims. */
const MODULE_PREFIXES: {
  prefix: string;
  moduleKey: "contract" | "obligation" | "receivable";
  planModuleKey: string;
}[] = [
  { prefix: "/obligations-hub", moduleKey: "obligation", planModuleKey: LicensingModuleKeys.ObligationHub },
  { prefix: "/obligations", moduleKey: "obligation", planModuleKey: LicensingModuleKeys.ObligationHub },
  { prefix: "/receivables-engine", moduleKey: "receivable", planModuleKey: LicensingModuleKeys.ReceivablesEngine },
  { prefix: "/receivables", moduleKey: "receivable", planModuleKey: LicensingModuleKeys.ReceivablesEngine },
  { prefix: "/contracts", moduleKey: "contract", planModuleKey: LicensingModuleKeys.ContractStudio },
  { prefix: "/library", moduleKey: "contract", planModuleKey: LicensingModuleKeys.ContractStudio },
];

/**
 * The catch-all for unknown paths. A path under a module's URL space that
 * the subscription leaves out reads as "Module Disabled" — the same page a
 * real route in that module shows — rather than "This page doesn't exist",
 * which told a reader on a trial that a feature they had heard of was
 * missing from the product instead of from their plan.
 */
export function ModuleAwareNotFound() {
  const { pathname } = useLocation();
  const { snapshot: licence } = useLicensing();

  const hit = MODULE_PREFIXES.find(
    (m) => pathname === m.prefix || pathname.startsWith(m.prefix + "/"),
  );
  const onPlan = !!licence && !licence.isUnrestricted;
  if (hit && onPlan && licence.modules?.[hit.planModuleKey] === false) {
    return <ModuleDisabled moduleKey={hit.moduleKey} planModuleKey={hit.planModuleKey} />;
  }

  return <NotFoundPage />;
}
